export function apiUrl()
{
    return 'api.php';
}

export default {apiUrl};